import { apiFetch } from './client'

export type CashForecastWeek = {
  week_start: string
  in_cents: number
  out_cents: number
  position_cents: number | null
  provisional?: boolean
  confidence: string
}

export type CashForecast = {
  horizon_weeks: number
  opening_cents: number | null
  bank_as_of: string | null
  weeks: CashForecastWeek[]
  lowest_week: CashForecastWeek | null
  suggested_action: string
  summary: string
  expected_in?: {
    open_pay_apps: Array<Record<string, unknown>>
    scheduled_billings: Array<Record<string, unknown>>
  }
  expected_out?: {
    weekly_lines: Array<{ key: string; label: string; cents_per_week: number }>
    recurring: Array<{ name: string; amount_cents: number; day_of_month: number }>
  }
  slow_payers: Array<{
    project_name: string
    owner_name?: string
    open_balance: number
    days_late: number
  }>
}

export async function fetchCashForecast(weeks = 13): Promise<CashForecast> {
  const json = await apiFetch<{ data: CashForecast }>('GET', `/api/cash/forecast?weeks=${weeks}`)
  return json.data
}

export async function proposeBankBalance(balanceDollars: number, asOfDate?: string) {
  return apiFetch<{ data: { confirmation_id: string; summary: string } }>('POST', '/api/cash/bank-balance/propose', {
    balance_dollars: balanceDollars,
    as_of_date: asOfDate,
  })
}

export async function confirmBankBalance(confirmationId: string) {
  return apiFetch<{ data: unknown }>('POST', '/api/cash/bank-balance/confirm', {
    confirmation_id: confirmationId,
  })
}
